<template>
    <div>
        <home-header :actIndex="actIndex" :imgList="imgList" :topStyle="topStyle" :logo="logo" ref="bannerRef"></home-header>
        <!--<home-about :about="about"></home-about>-->
        <home-data></home-data>
        <home-business :businessInfo="business" ref="businessRef"></home-business>
        <home-develop :developInfo="develop" ref="developRef"></home-develop>
        <home-advantage :advantageInfo="advantage"></home-advantage>
        <home-partner :partnerInfo="partner" ref="partnerRef"></home-partner>
        <home-need></home-need>
        <home-footer :bottom="bottom" :bottomInfo="bottomInfo"></home-footer>
    </div>
</template>

<script>
import HomeHeader from '@/components/mobile/Header'
import HomeAbout from '@/components/mobile/HomeAbout'
import HomeData from '@/components/mobile/HomeData'
import HomeBusiness from '@/components/mobile/HomeBusiness'
import HomeAdvantage from '@/components/mobile/HomeAdvantage'
import HomeDevelop from '@/components/mobile/HomeDevelop'
import HomePartner from '@/components/mobile/Partner'
import HomeNeed from '@/components/mobile/HomeNeed'
import HomeFooter from '@/components/mobile/Footer'
export default {
    name: 'Home',
    data () {
        return {
            topStyle: "padding-bottom: 175%",
            actIndex: 0,
            imgList: [],
            about: {},
            bottom: {},
            logo: '',
            bottomInfo: {},
            partner: [],
            business: [],
            advantage:[],
            develop:[]
        }
    },
    components: {
        HomeHeader,
        HomeAbout,
        HomeData,
        HomeBusiness,
        HomeAdvantage,
        HomeDevelop,
        HomePartner,
        HomeNeed,
        HomeFooter
    },
    mounted () {
        this.Pc_Moblie()
        this.getPageData()
    },
    methods: {
        _isMobile () {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        Pc_Moblie () {    
            if(this._isMobile()) {
                this.$router.replace('/m_home');
            }else{
                this.$router.replace('/home');
            }
        },
        getPageData () {
            this.$http.post('home/index/m_homeinfo',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.imgList = res.data.banner
                this.about = res.data.company[0]
                this.bottomInfo = res.data.contact[0]
                this.partner = res.data.partner
                this.business = res.data.work
                this.advantage = res.data.software
                this.develop = res.data.flow
                this.$nextTick(()=>{
                    this.$refs.bannerRef.imgSwiper();
                    this.$refs.partnerRef.imgSwiper();
                    this.$refs.businessRef.imgSwiper();
                    this.$refs.developRef.imgSwiper();
                })
            })
        },
    }
}
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// src/views/mobile/Home.vue